export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5502.54c4856c.jpg";